export const UNDERWRITING_UI_EMBED_PAGES = {
  POLICY_DETAILS: "policy_details",
  POLICY_COMPARE: "policy_compare",
  EXECUTION_AUDIT: "execution_audit",
  POLICY_SIMULATE: "policy_simulate",
} as const;

export type UnderwritingUiEmbedPage =
  (typeof UNDERWRITING_UI_EMBED_PAGES)[keyof typeof UNDERWRITING_UI_EMBED_PAGES];
